module.exports = __webpack_public_path__ + "img/3.4dc4e2d8.jpg";